module.exports = __webpack_public_path__ + "static/img/bg.05925a1b.png";